import React from 'react';
import classNames from 'classnames';
import './SlideoutContent.scss';

const Empty = () => (
  <div className="slideout-content__empty">Nothing found</div>
);

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export const SlideoutContent = ({ className, children }: Props) => {
  let content = children || <Empty />;
  if (Array.isArray(children)) {
    if (!children.length) content = <Empty />;
  }

  return (
    <div className={classNames(className, 'slideout-content')}>{content}</div>
  );
};
